import { render, staticRenderFns } from "./UpdateFormModal.vue?vue&type=template&id=97374526&scoped=true&"
import script from "./UpdateFormModal.vue?vue&type=script&lang=js&"
export * from "./UpdateFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97374526",
  null
  
)

export default component.exports